import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import Card5 from "../Images/Profiles/Joseph.jpg";
import "../Profiles/Profile.css"; // Using the common Profile CSS
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function JosephNdemereArineitwe() {
  return (
    <div className="ne-page">
      <SEO
        title="Mr. Joseph Ndemere Arineitwe - Director General"
        description="Mr. Joseph Ndemere Arineitwe is the Director General at CIRCODU with a Master's degree in Mechanical Engineering and a Bachelor's degree in Mechanical Engineering."
        keywords="Joseph Ndemere Arineitwe, Director General, CIRCODU, Master's degree, Bachelor's degree, Mechanical Engineering"
        url="/joseph-ndemere-arineitwe"
        image={Card5}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Mr. Joseph Ndemere Arineitwe</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/top-management">
              Top Management
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Mr. Joseph Ndemere Arineitwe
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card5} alt="Mr. Joseph Ndemere Arineitwe" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">
                  Mr. Joseph Ndemere Arineitwe
                </h1>
                <p className="profile-card__role">Director General</p>
                <p className="profile-card__specialty">
                  Renewable Energy and Carbon Finance Specialist
                </p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Joseph possesses a Master's degree in Mechanical Engineering
                  with a specialization in Sustainable Energy Engineering,
                  obtained from the Royal Institute of Technology (KTH) in
                  Sweden. His academic journey also includes a Bachelor's degree
                  in Mechanical Engineering conferred upon him by Makerere
                  University. Furthermore, he has earned a Certificate in Energy
                  Systems and Energy Carriers in developing countries,
                  encompassing solar, hydro, wind, biomass, and related
                  subjects.
                </p>
                <p>
                  With a remarkable tenure exceeding a decade, Joseph has played
                  a pivotal role in steering the implementation of all endeavors
                  undertaken by the Centre for Integrated Research and Community
                  Development Uganda (CIRCODU). His extensive experience
                  positions him as one of the foremost seasoned professionals in
                  the realm of Biomass Energy Systems and Interventions,
                  offering unparalleled services in Study Implementation,
                  Assessment, Monitoring, and Evaluation within Uganda and the
                  broader East African region.
                </p>
                <p>
                  Joseph has skillfully demonstrated his aptitude in
                  conceptualizing, designing, and executing a diverse array of
                  Study Projects centered around Biomass Energy. His expertise
                  has been applied across a spectrum of communities and
                  settings, both locally in Uganda and beyond its borders. Among
                  his notable achievements, he has orchestrated the planning and
                  execution of various studies for distinct organizations within
                  Uganda. These encompass a range of study types, including
                  Feasibility Studies, Baseline Studies, Project Studies, Market
                  Intelligence Studies, Willingness-To-Pay Studies, and Impact
                  Studies. Notable organizations that have benefited from his
                  expertise include Finnfund, SNV, Hivos Foundation, Biogas
                  Solutions Uganda Limited, Habitat for Humanity Uganda, World
                  Wide Fund for Nature, Impact Carbon, My climate, and
                  Environment Conservation Trust Uganda, among others.
                </p>
                <p>
                  Joseph's expertise extends to the realm of National Renewable
                  Energy Studies, where he has undertaken significant
                  initiatives such as the National Charcoal Survey for Uganda in
                  2015, the National Baseline Study on Clean Cooking in Uganda
                  in 2019, and the National Baseline Survey on Existing,
                  Planned, and Demanded National Standards and Quality
                  Guidelines for the Renewable Energy Sector in 2018-2019. These
                  initiatives have been conducted in collaboration with entities
                  like the Ministry of Energy and Mineral Development (MEMD),
                  Uganda National Alliance for Clean Cooking (UNACC), and Uganda
                  National Renewable Energy and Energy Efficiency Association
                  (UNREEEA).
                </p>
                <p>
                  In addition to his comprehensive technical proficiency, Joseph
                  possesses a unique ability to craft Technical Reports that are
                  accessible and understandable to both technical and
                  non-technical audiences. His extensive research activities
                  have primarily revolved around the Development and Utilization
                  of Biogas Technology, Biomass Gasification for Industrial
                  Thermal Applications, Behavioral Change Interventions for the
                  Adoption and Use of Cookstoves, and Marketing and Distribution
                  Approaches for Cookstoves and Solar Lamps.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://www.linkedin.com/in/joseph-ndemere-arineitwe-56474625/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/josephndemere"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/josephndemere.arineitwe/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256782433627"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:joseph.ndemere@circodu.org.ug"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default JosephNdemereArineitwe;
